export default function (direction: number): string {
    // reader - считыватель, к которому приложена карта. 1- вход, 2 - выход.

    if (direction === 1) return 'enter';
    else return 'exit';
}
